import { MODAL_EXPORT_CSV, MODAL_SHARE } from '@components/App/Modal/constants'
import { Tab } from '@components/App/Modal/Share/Share'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

import { useProjectAccess } from '@/hooks'
import { EXPORT_PERMISSION } from '@/permissions/project/definitions'

export const useExportAsCsv = (withBack?: boolean) => {
  const dispatch = useDispatch()

  const { hasAccess: exportable } = useProjectAccess(
    EXPORT_PERMISSION.FILE_FORMATS
  )

  return () => {
    if (!exportable) {
      return
    }

    dispatch(
      openModal({
        modalType: MODAL_EXPORT_CSV,
        modalProps: {
          ...(withBack && {
            onBack: {
              to: MODAL_SHARE,
              params: {
                activeTab: Tab.Export,
              },
            },
          }),
        },
      })
    )
  }
}
